// import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
// import { useSelector } from 'react-redux';
// import Link from 'next/link';
// import OnCartProduct from '~/components/elements/products/OnCartProduct';
// import useEcomerce from '~/hooks/useEcomerce';
// import { calculateAmount } from '~/utilities/ecomerce-helpers';
// import useGetProducts from '~/hooks/useGetProducts';
// import useUserBirthday from '~/hooks/useUserBirthday';
// import { useGlobalPopup } from '~/components/GlobalPopupProvider';
// import {
//     groupAgeRatings,
//     splitProductsByUserAge,
//     getAgeBlockedText,
// } from '~/utilities/ageCheck';
// import { getCouponLabel } from '~/utilities/checkoutTotals';
// import { isCartItemSelected } from '~/utilities/cartSelection';
// import { useConfirmRemove } from '~/components/elements/products/modules/ConfirmRemoveModal';

// const MIN_ORDER_VALUE = 20.00;
// const MINICART_WIDTH = 400;
// const BOX_ICON_SIZE = 18;

// const BOX_ICON_BOX_WIDTH = 26;
// const BOX_ICON_BOX_HEIGHT = 26;

// const SALE_ICON_SIZE = 18;
// const SALE_BOX_WIDTH = 26;
// const SALE_BOX_HEIGHT = 26;

// const CLOSE_DELAY = 250;

// const placeholderURL = '/static/img/products/rawento-product-placeholder.webp';

// const buildImageUrl = (image) => {
//     if (!image || image === 'No base_image_thumbnail') return placeholderURL;
//     if (String(image).startsWith('http')) return image;
//     return `${process.env.NEXT_PUBLIC_FRONTEND_URL}/images/${image}`;
// };

// const readCouponFromStorage = () => {
//     try {
//         const saved = typeof window !== 'undefined' ? localStorage.getItem('appliedCoupon') : null;
//         return saved ? JSON.parse(saved) : null;
//     } catch (e) { return null; }
// };

// const EuroSup = () => (
//     <sup
//         style={{
//             fontSize: '0.6em',
//             fontWeight: 500,
//             marginLeft: '1px',
//             lineHeight: 0,
//         }}
//     >
//         €
//     </sup>
// );

// const MiniCart = () => {
//     const { removeItem } = useEcomerce();
//     const { showPopup } = useGlobalPopup();
//     const { confirmRemove, confirmRemoveModal } = useConfirmRemove();
//     const cartItems = useSelector(({ ecomerce }) => ecomerce.cartItems);
//     const isLoggedIn = typeof window !== 'undefined' && !!localStorage.getItem('jwt');
//     const { getStrapiProducts, products } = useGetProducts();
//     const birthday = useUserBirthday();

//     const [pulseCartCount, setPulseCartCount] = useState(false);
//     const [showCart, setShowCart] = useState(false);
//     const [pinned, setPinned] = useState(false);

//     const [appliedCoupon, setAppliedCoupon] = useState(readCouponFromStorage);

//     const rootRef = useRef(null);
//     const closeTimerRef = useRef(null);
//     const prevCartTotalRef = useRef(0);
//     const isInitialMountRef = useRef(true);
//     const mountedRef = useRef(false);

//     const isOpen = showCart || pinned;

//     useEffect(() => {
//         return () => clearTimeout(closeTimerRef.current);
//     }, []);

//     useEffect(() => {
//         if (!pinned) return;

//         const onDown = (e) => {
//             if (rootRef.current && rootRef.current.contains(e.target)) return;
//             if (
//                 e.target.closest &&
//                 e.target.closest('[role="dialog"], [class*="modal"], [class*="popup"]')
//             ) return;
//             setPinned(false);
//             setShowCart(false);
//         };
//         const onKey = (e) => {
//             if (e.key === 'Escape') {
//                 setPinned(false);
//                 setShowCart(false);
//             }
//         };

//         document.addEventListener('mousedown', onDown);
//         document.addEventListener('keydown', onKey);
//         return () => {
//             document.removeEventListener('mousedown', onDown);
//             document.removeEventListener('keydown', onKey);
//         };
//     }, [pinned]);

//     useEffect(() => {
//         if (!isOpen || !rootRef.current) return;
//         const el = rootRef.current.querySelector('.ps-cart__content');
//         if (!el) return;
//         el.style.setProperty('visibility', 'visible', 'important');
//         el.style.setProperty('opacity', '1', 'important');
//         el.style.setProperty('display', 'block', 'important');
//         el.style.setProperty('pointer-events', 'auto', 'important');
//         el.style.setProperty('transform', 'translate(0, 0)', 'important');
//     });

//     useEffect(() => {
//         const sync = () => {
//             const fresh = readCouponFromStorage();
//             setAppliedCoupon((prev) => {
//                 const prevStr = prev ? JSON.stringify(prev) : 'null';
//                 const freshStr = fresh ? JSON.stringify(fresh) : 'null';
//                 return prevStr === freshStr ? prev : fresh;
//             });
//         };
//         const onStorage = (e) => { if (e.key === 'appliedCoupon') sync(); };

//         window.addEventListener('couponChanged', sync);
//         window.addEventListener('storage', onStorage);
//         return () => {
//             window.removeEventListener('couponChanged', sync);
//             window.removeEventListener('storage', onStorage);
//         };
//     }, []);

//     useEffect(() => {
//         const validateCouponOnMount = async () => {
//             const saved = readCouponFromStorage();
//             if (!saved?.code) return;

//             try {
//                 const token = typeof window !== 'undefined' ? localStorage.getItem('jwt') : null;
//                 const userRaw = typeof window !== 'undefined' ? localStorage.getItem('user') : null;
//                 if (!token || !userRaw) return;

//                 let user = null;
//                 try { user = JSON.parse(userRaw); } catch (e) { return; }
//                 const email = user?.email || user?.data?.email || user?.user?.email || '';
//                 if (!email) return;

//                 const response = await fetch(
//                     `${process.env.NEXT_PUBLIC_API_URL}/newsletters/status?email=${encodeURIComponent(email)}`,
//                     { headers: { Authorization: `Bearer ${token}` }, cache: 'no-store' }
//                 );
//                 if (!response.ok) return;
//                 const data = await response.json();

//                 if (
//                     data?.welcome_coupon_redeemed &&
//                     data?.welcome_coupon_code?.toLowerCase() === saved.code.toLowerCase()
//                 ) {
//                     try { localStorage.removeItem('appliedCoupon'); } catch (e) {}
//                     setAppliedCoupon(null);
//                     setTimeout(() => window.dispatchEvent(new Event('couponChanged')), 0);
//                 }
//             } catch (e) {
//                 console.error('MiniCart coupon validation failed:', e);
//             }
//         };

//         validateCouponOnMount();
//     }, []);

//     const handleRemoveCoupon = useCallback(async () => {
//         const confirmed = await confirmRemove({
//             title: 'Aktionscode entfernen?',
//             message: 'Möchtest du den Aktionscode wirklich entfernen? Der Rabatt wird dann nicht mehr auf deine Bestellung angewendet.',
//             itemName: appliedCoupon?.code || '',
//         });
//         if (!confirmed) return;
//         try { localStorage.removeItem('appliedCoupon'); } catch (e) {}
//         setAppliedCoupon(null);
//         setTimeout(() => window.dispatchEvent(new Event('couponChanged')), 0);
//         showPopup({ type: 'success', title: 'Entfernt', detail: 'Aktionscode wurde entfernt.' });
//     }, [confirmRemove, appliedCoupon, showPopup]);

//     const handleRemoveItem = useCallback(async (e, productId, productTitle, info = {}) => {
//         e.preventDefault();
//         e.stopPropagation();

//         const confirmed = await confirmRemove({
//             title: 'Aus Warenkorb entfernen?',
//             message: 'Artikel aus deinem Warenkorb entfernen?',
//             itemName: productTitle || '',
//             imageUrl: buildImageUrl(info.image),
//             price: info.price,
//             oldPrice: info.oldPrice,
//             quantity: info.quantity,
//         });
//         if (!confirmed) return;

//         try {
//             await removeItem({ id: productId }, cartItems, 'cart');
//             showPopup({ type: 'info', title: 'Artikel entfernt', detail: `„${productTitle || 'Artikel'}" wurde aus dem Warenkorb entfernt.` });
//         } catch (err) {
//             console.error('Error removing item:', err);
//             showPopup({ type: 'error', title: 'Fehler', detail: 'Artikel konnte nicht entfernt werden.' });
//         }
//     }, [confirmRemove, removeItem, cartItems, showPopup]);

//     function getCartProducts() {
//         if (cartItems.length > 0) {
//             const query = {
//                 filters: { id: { $in: cartItems.map((item) => item.id) } },
//                 populate: { shippings: { fields: ['shipping_type', 'shipping_cost'] } },
//             };
//             getStrapiProducts(query);
//         }
//     }

//     useEffect(() => { getCartProducts(); }, [cartItems]);

//     const totalQuantity = useMemo(() => cartItems.reduce((total, item) => total + (item.quantity || 1), 0), [cartItems]);

//     const triggerPulseIfAdded = useCallback(() => {
//         const currentTotal = totalQuantity;
//         const prevTotal = prevCartTotalRef.current;
//         if (mountedRef.current && !isInitialMountRef.current && currentTotal > prevTotal) {
//             setPulseCartCount(true);
//             setTimeout(() => setPulseCartCount(false), 500);
//         }
//         prevCartTotalRef.current = currentTotal;
//     }, [totalQuantity]);

//     useEffect(() => { mountedRef.current = true; return () => { mountedRef.current = false; }; }, []);
//     useEffect(() => {
//         if (isInitialMountRef.current) { isInitialMountRef.current = false; prevCartTotalRef.current = totalQuantity; return; }
//         triggerPulseIfAdded();
//     }, [totalQuantity, triggerPulseIfAdded]);

//     const cartProducts = useMemo(() => {
//         if (cartItems.length === 0) return [];
//         return products.map((product) => {
//             const attrs = product?.attributes || {};
//             const variants = [];

//             for (let n = 1; n <= 4; n += 1) {
//                 const name = attrs[`variant_name_${n}`];
//                 const value = attrs[`variant_value_${n}`];

//                 if (name && value) variants.push(`${name} ${value}`);
//             }

//             const shippingInfo = product?.attributes?.shippings?.data?.attributes;
//             const shipping_type = shippingInfo?.shipping_type || '';
//             const cartItem = cartItems.find((item) => String(item.id) === String(product.id));
//             const currentQuantity = cartItem?.quantity ?? 0;
//             const lowestPrice30d =
//                 product.attributes.lowestPrice30d != null ? Number(product.attributes.lowestPrice30d) : null;

//             const inStockRaw = product?.attributes?.in_stock;
//             const hasStockInfo = inStockRaw === true || inStockRaw === false;
//             const isAvailable = !hasStockInfo || inStockRaw === true;

//             const minAge = Number(product?.attributes?.minAge) || 0;
//             const ageRatingType = product?.attributes?.age_rating_type || null;

//             return {
//                 id: product.id,
//                 title: product.attributes.title || 'Untitled Product',
//                 slug: product.attributes.slug || 'untitled-product',
//                 thumbnailImage: product.attributes.thumbnail || null,
//                 price: product.attributes.price || 0,
//                 lowestPrice30d,
//                 base_image_thumbnail: product.attributes.base_image_thumbnail || null,
//                 quantity: currentQuantity,
//                 productVariants: variants,
//                 shipping_type,
//                 isAvailable,
//                 minAge,
//                 ageRatingType,
//                 selected: isCartItemSelected(cartItem),
//             };
//         });
//     }, [products, cartItems]);

//     const inStockCartProducts = useMemo(
//         () => cartProducts.filter((p) => p.isAvailable),
//         [cartProducts]
//     );
//     const unavailableCartProducts = useMemo(
//         () => cartProducts.filter((p) => !p.isAvailable),
//         [cartProducts]
//     );

//     const ageSplit = useMemo(
//         () => splitProductsByUserAge(inStockCartProducts, birthday),
//         [inStockCartProducts, birthday]
//     );
//     const availableCartProducts = ageSplit.allowed;
//     const ageBlockedCartProducts = ageSplit.blocked;

//     // Nur die zur Kasse ausgewählten Artikel zählen für Summe, Altersprüfung und Kasse
//     const selectedCartProducts = useMemo(
//         () => availableCartProducts.filter((p) => p.selected),
//         [availableCartProducts]
//     );

//     const ageGroups = useMemo(
//         () => groupAgeRatings(selectedCartProducts),
//         [selectedCartProducts]
//     );

//     const cartIsEmpty = cartItems.length === 0;

//     const isLoadingCartProducts = !cartIsEmpty && cartProducts.length === 0;

//     const cartAmount = useMemo(
//         () => selectedCartProducts.reduce((sum, p) => sum + p.price * p.quantity, 0),
//         [selectedCartProducts]
//     );

//     const totalSavings30d = useMemo(
//         () =>
//             selectedCartProducts.reduce((sum, p) => {
//                 if (p.lowestPrice30d != null && p.lowestPrice30d > p.price) {
//                     return sum + (p.lowestPrice30d - p.price) * p.quantity;
//                 }
//                 return sum;
//             }, 0),
//         [selectedCartProducts]
//     );
//     const hasSaleItems = useMemo(
//         () => selectedCartProducts.some((p) => p.lowestPrice30d != null && p.lowestPrice30d > p.price),
//         [selectedCartProducts]
//     );

//     const couponDiscount = useMemo(() => {
//         const amount = Number(appliedCoupon?.welcome_coupon_discount_amount);
//         if (!appliedCoupon || !amount || amount <= 0) return 0;

//         if (appliedCoupon.welcome_coupon_discount_type === 'percent') {
//             return Math.round(cartAmount * (amount / 100) * 100) / 100;
//         }

//         return Math.min(amount, cartAmount);
//     }, [cartAmount, appliedCoupon]);
//     const cartAmountFinal = useMemo(() => cartAmount - couponDiscount, [cartAmount, couponDiscount]);

//     const hasProducts = availableCartProducts.length > 0;
//     const hasSelectedProducts = selectedCartProducts.length > 0;

//     const onlyDigitalProducts = useMemo(
//         () =>
//             hasSelectedProducts &&
//             selectedCartProducts.every(
//                 (product) => product.shipping_type === 'Digitaler Versand'
//             ),
//         [selectedCartProducts, hasSelectedProducts]
//     );

//     const isCheckoutEnabled = useMemo(
//         () => hasSelectedProducts && (onlyDigitalProducts || cartAmount >= MIN_ORDER_VALUE),
//         [hasSelectedProducts, onlyDigitalProducts, cartAmount]
//     );

//     const missing = isCheckoutEnabled
//         ? 0
//         : Math.max(0, MIN_ORDER_VALUE - cartAmount);

//     const progress = isCheckoutEnabled
//         ? 100
//         : Math.min(100, (cartAmount / MIN_ORDER_VALUE) * 100);

//     const formatAmount = (amount) =>
//         new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);

//     const currencyStyle   = { fontSize: '0.65em', fontWeight: 500, marginLeft: '1px' };
//     const emptyCartStyle  = { display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '24px 12px', borderBottom: 'none' };
//     const imgStyle        = { maxWidth: '100%', height: 'auto', display: 'block', width: '21.5rem', objectFit: 'contain' };
//     const titleStyle      = { margin: '16px 0px 0px', fontSize: '21px', fontWeight: '600', lineHeight: '27.3px', textAlign: 'center' };
//     const subtitleStyle   = { margin: '0px 0px 24px', fontSize: '14px', fontWeight: '400', lineHeight: '21px', textAlign: 'center', color: '#666' };
//     const rowStyle        = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', color: '#444', marginBottom: '5px' };
//     const discountStyle   = { color: '#b11211', fontWeight: 600, whiteSpace: 'nowrap' };
//     const couponStyle     = { color: '#1a7a32', fontWeight: 600, whiteSpace: 'nowrap' };
//     const dividerStyle    = { border: 'none', borderTop: '1px solid rgba(0,0,0,0.1)', margin: '8px 0' };

//     const unavailableBanner = unavailableCartProducts.length > 0 ? (
//         <div className="minicart-unavailable-banner">
//             <span className="minicart-unavailable-icon">!</span>
//             <span>
//                 {unavailableCartProducts.length === 1
//                     ? '1 Artikel ist aktuell nicht verfügbar und wird nicht mit bestellt.'
//                     : `${unavailableCartProducts.length} Artikel sind aktuell nicht verfügbar und werden nicht mit bestellt.`}
//             </span>
//         </div>
//     ) : null;

//     const ageBlockedBanner = ageBlockedCartProducts.length > 0 ? (
//         <div className="minicart-unavailable-banner minicart-age-blocked-banner">
//             <span className="minicart-unavailable-icon minicart-age-blocked-icon">!</span>
//             <span>{getAgeBlockedText(ageBlockedCartProducts)}</span>
//         </div>
//     ) : null;

//     const ageBanners = ageGroups.map((group) => (
//         <div
//             key={group.key}
//             className={`minicart-age-banner minicart-age-banner--${group.limit}`}
//         >
//             <span className={`minicart-age-icon minicart-age-icon--${group.limit}`}>
//                 {group.limit}
//             </span>
//             <span>
//                 {group.count === 1 ? '1 Artikel' : `${group.count} Artikel`} ab {group.limit} Jahren ({group.label}).{' '}
//                 {group.limit === 18
//                     ? 'Vor der Bestellung ist eine Altersverifizierung erforderlich, zusätzliche Prüfung bei Zustellung durch DHL.'
//                     : 'Das Alter wird bei Zustellung durch DHL geprüft.'}
//             </span>
//         </div>
//     ));

//     const loadingPlaceholder = (
//         <div className="ps-cart__items minicart-loading" style={emptyCartStyle}>
//             <div className="minicart-spinner" />
//             <p style={{ ...subtitleStyle, margin: '12px 0 0' }}>Warenkorb wird geladen …</p>
//         </div>
//     );

//     const cartItemsContent = useMemo(() => {
//         if (!isLoggedIn && cartIsEmpty) {
//             return (
//                 <div className="ps-cart__content">
//                     <div className="ps-cart__items" style={emptyCartStyle}>
//                         <img role="presentation" src="/static/img/sale/empty-cart.svg" alt="" style={{ ...imgStyle, width: '75px', height: '75px' }} />
//                         <p style={titleStyle}>Dein Warenkorb ist noch leer</p>
//                         <p style={subtitleStyle}>Viele Produkte warten auf dich!</p>
//                         <div style={{ width: '100%', padding: '0 20px', display: 'flex', justifyContent: 'center' }}>
//                             <Link href="/account/login" className="ps-btn">Jetzt anmelden</Link>
//                         </div>
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="ps-cart__content">
//                 {unavailableBanner}
//                 {ageBlockedBanner}
//                 {ageBanners}

//                 {isLoadingCartProducts ? (
//                     loadingPlaceholder
//                 ) : hasProducts ? (
//                     <div className="ps-cart__items">
//                         {availableCartProducts.map((item) => (
//                             <OnCartProduct
//                                 product={item}
//                                 quantity={item.quantity}
//                                 key={item.id}
//                                 onAddToQueue={showPopup}
//                                 onRemove={(e) => handleRemoveItem(e, item.id, item.title, {
//                                     image: item.base_image_thumbnail,
//                                     price: item.price,
//                                     oldPrice: item.lowestPrice30d != null && item.lowestPrice30d > item.price ? item.lowestPrice30d : null,
//                                     quantity: item.quantity,
//                                 })}
//                             >
//                                 {item.productVariants.length > 0 && (
//                                     <div className="ps-product__variants">
//                                         {item.productVariants.map((variant, index) => {
//                                             const [name, ...valueParts] = variant.split(' ');
//                                             const value = valueParts.join(' ');
//                                             const displayName = name.includes(':') ? name : `${name}:`;
//                                             return (<div key={index} className="ps-product__variant"><strong>{displayName}</strong> {value}</div>);
//                                         })}
//                                     </div>
//                                 )}
//                                 {!item.selected && (
//                                     <div className="ps-product__variant" style={{ color: '#b11211' }}>
//                                         Nicht für die Kasse ausgewählt
//                                     </div>
//                                 )}
//                             </OnCartProduct>
//                         ))}
//                     </div>
//                 ) : (

//                     cartIsEmpty && unavailableCartProducts.length === 0 && (
//                         <div className="ps-cart__items" style={emptyCartStyle}>
//                             <img role="presentation" src="/static/img/sale/empty-cart.svg" alt="" style={{ ...imgStyle, width: '75px', height: '75px' }} />
//                             <p style={titleStyle}>Dein Warenkorb ist noch leer</p>
//                             <p style={subtitleStyle}>Viele Produkte warten auf dich!</p>
//                         </div>
//                     )
//                 )}

//                 <div className="ps-cart__footer">
//                     {hasProducts && (
//                         <>
//                             <div style={{ marginBottom: '10px' }}>

//                                 {hasSaleItems && totalSavings30d > 0 && (
//                                     <div style={{ display: 'block', width: '100%', padding: 0, margin: '0 0 8px' }}>
//                                         <div
//                                             style={{
//                                                 display: 'flex',
//                                                 width: '100%',
//                                                 backgroundColor: '#ffffff',
//                                                 borderRadius: '8px',
//                                                 overflow: 'hidden',
//                                                 height: `${SALE_BOX_HEIGHT}px`,
//                                             }}
//                                         >
//                                             <div
//                                                 style={{
//                                                     display: 'flex',
//                                                     justifyContent: 'center',
//                                                     flexDirection: 'column',
//                                                     backgroundColor: 'rgb(177, 18, 17)',
//                                                     padding: 0,
//                                                     width: `${SALE_BOX_WIDTH}px`,
//                                                     minWidth: `${SALE_BOX_WIDTH}px`,
//                                                     alignItems: 'center',
//                                                     boxSizing: 'border-box',
//                                                 }}
//                                             >
//                                                 <svg
//                                                     xmlns="http://www.w3.org/2000/svg"
//                                                     width={SALE_ICON_SIZE}
//                                                     height={SALE_ICON_SIZE}
//                                                     viewBox="0 0 24 24"
//                                                     fill="white"
//                                                 >
//                                                     <path d="M21.41 11.58L12.41 2.58A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.84ZM7 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" />
//                                                 </svg>
//                                             </div>

//                                             <div
//                                                 style={{
//                                                     flex: 'auto',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     padding: '0 8px',
//                                                 }}
//                                             >
//                                                 <div
//                                                     style={{
//                                                         flex: '1 1 auto',
//                                                         minWidth: 0,
//                                                         fontSize: '1.4rem',
//                                                         lineHeight: '1.4285714286em',
//                                                         whiteSpace: 'nowrap',
//                                                     }}
//                                                 >
//                                                     SALE Sie sparen:
//                                                 </div>

//                                                 <div
//                                                     style={{
//                                                         flex: '0 0 auto',
//                                                         marginLeft: 'auto',
//                                                         textAlign: 'right',
//                                                         fontWeight: 700,
//                                                         fontSize: '1.4rem',
//                                                         lineHeight: '1.4285714286em',
//                                                         whiteSpace: 'nowrap',
//                                                         color: 'rgb(177, 18, 17)',
//                                                     }}
//                                                 >
//                                                     <strong>
//                                                         {formatAmount(totalSavings30d)}
//                                                         <EuroSup />
//                                                     </strong>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}

//                                 <div style={rowStyle}>
//                                     <span>Zwischensumme</span>
//                                     <span style={{ fontWeight: 500 }}>
//                                         {formatAmount(cartAmount)}<sup style={currencyStyle}>€</sup>
//                                     </span>
//                                 </div>

//                                 {appliedCoupon?.code && couponDiscount > 0 && (
//                                     <div
//                                         style={{
//                                             display: 'flex',
//                                             backgroundColor: 'transparent',
//                                             borderRadius: '8px',
//                                             overflow: 'hidden',
//                                             margin: '8px 0',
//                                             height: `${BOX_ICON_BOX_HEIGHT}px`,
//                                         }}
//                                     >
//                                         <div
//                                             style={{
//                                                 display: 'flex',
//                                                 justifyContent: 'center',
//                                                 flexDirection: 'column',
//                                                 alignItems: 'center',
//                                                 backgroundColor: '#3E935E',
//                                                 padding: 0,
//                                                 width: `${BOX_ICON_BOX_WIDTH}px`,
//                                                 minWidth: `${BOX_ICON_BOX_WIDTH}px`,
//                                                 boxSizing: 'border-box',
//                                             }}
//                                         >
//                                             <img
//                                                 src="/static/img/icons/icon-sale.svg"
//                                                 alt="Aktionscode"
//                                                 width={BOX_ICON_SIZE}
//                                                 height={BOX_ICON_SIZE}
//                                                 style={{
//                                                     filter: 'brightness(0) invert(1)',
//                                                 }}
//                                             />
//                                         </div>

//                                         <div
//                                             style={{
//                                                 flex: 'auto',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 padding: '0 8px',
//                                                 gap: '4px',
//                                                 flexWrap: 'nowrap',
//                                             }}
//                                         >
//                                             <div
//                                                 style={{
//                                                     flex: '1 1 auto',
//                                                     minWidth: 0,
//                                                     fontSize: '1.2rem',
//                                                     whiteSpace: 'nowrap',
//                                                     overflow: 'hidden',
//                                                     textOverflow: 'ellipsis',
//                                                     lineHeight: '1.4285714286em',
//                                                 }}
//                                             >
//                                                 Aktionscode{' '}
//                                                 <strong>{appliedCoupon.code}</strong>{' '}
//                                                 – {getCouponLabel(appliedCoupon)}
//                                             </div>

//                                             <div
//                                                 style={{
//                                                     flex: '0 0 auto',
//                                                     marginLeft: 'auto',
//                                                     textAlign: 'right',
//                                                     fontWeight: 700,
//                                                     fontSize: '1.2rem',
//                                                     lineHeight: '1.4285714286em',
//                                                     whiteSpace: 'nowrap',
//                                                     color: 'rgb(177, 18, 17)',
//                                                 }}
//                                             >
//                                                 <strong>
//                                                     −{formatAmount(couponDiscount)}
//                                                     <EuroSup />
//                                                 </strong>
//                                             </div>
//                                         </div>

//                                         <button
//                                             type="button"
//                                             onClick={handleRemoveCoupon}
//                                             aria-label="Aktionscode entfernen"
//                                             title="Aktionscode entfernen"
//                                             style={{
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 flex: '0 0 auto',
//                                                 width: '28px',
//                                                 padding: 0,
//                                                 border: 0,
//                                                 background: 'transparent',
//                                                 color: '#888',
//                                                 fontSize: '12px',
//                                                 lineHeight: 1,
//                                                 cursor: 'pointer',
//                                             }}
//                                             onMouseEnter={(e) => (e.currentTarget.style.color = '#b11211')}
//                                             onMouseLeave={(e) => (e.currentTarget.style.color = '#888')}
//                                         >
//                                             ✕
//                                         </button>
//                                     </div>
//                                 )}

//                                 <hr style={dividerStyle} />

//                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '3px' }}>
//                                     <span style={{ fontSize: '13px', fontWeight: 700, color: '#111' }}>
//                                         Gesamtsumme{' '}
//                                         <span style={{ fontSize: '11px', fontWeight: 400, color: '#777' }}>(inkl. MwSt.)</span>
//                                     </span>
//                                     <span style={{ fontSize: '15px', fontWeight: 700, color: '#111' }}>
//                                         {formatAmount(cartAmountFinal)}<sup style={currencyStyle}>€</sup>
//                                     </span>
//                                 </div>

//                                 {!onlyDigitalProducts && (
//                                     <div style={{ fontSize: '11px', color: '#777' }}>zzgl. Versandkosten</div>
//                                 )}
//                             </div>

//                             {hasSelectedProducts && !isCheckoutEnabled && !onlyDigitalProducts && (
//                                 <div style={{ marginBottom: '12px' }}>
//                                     <p style={{ fontSize: '12px', margin: '0 0 6px 0', color: '#333', lineHeight: '1.4' }}>
//                                         Es fehlen <strong>{formatAmount(missing)}<sup style={currencyStyle}>€</sup></strong> bis zum Mindestbestellwert von {formatAmount(MIN_ORDER_VALUE)}<sup style={currencyStyle}>€</sup>
//                                     </p>
//                                     <div style={{ position: 'relative', height: '6px', borderRadius: '999px', background: 'rgb(211,211,211)', overflow: 'hidden' }}>
//                                         <div style={{ height: '6px', width: `${progress}%`, background: 'rgb(0,100,0)', transition: 'width 0.15s ease-out' }} />
//                                     </div>
//                                 </div>
//                             )}

//                             {hasProducts && !hasSelectedProducts && (
//                                 <p style={{ fontSize: '12px', margin: '0 0 12px', color: '#b11211' }}>
//                                     Wähle im Warenkorb mindestens einen Artikel für die Kasse aus.
//                                 </p>
//                             )}
//                         </>
//                     )}

//                     <hr style={dividerStyle} />

//                     <figure>
//                         <Link href="/account/shopping-cart" className="ps-btn">Warenkorb</Link>
//                         <Link
//                             href={isCheckoutEnabled ? '/account/checkout' : '#'}
//                             className={`ps-btn ${isCheckoutEnabled ? '' : 'ps-btn--disabled'}`}
//                             aria-disabled={!isCheckoutEnabled}
//                             tabIndex={isCheckoutEnabled ? 0 : -1}
//                             onClick={(event) => {
//                                 if (!isCheckoutEnabled) {
//                                     event.preventDefault();
//                                     event.stopPropagation();
//                                 }
//                             }}
//                             style={{
//                                 opacity: isCheckoutEnabled ? 1 : 0.45,
//                                 pointerEvents: isCheckoutEnabled ? 'auto' : 'none',
//                                 cursor: isCheckoutEnabled ? 'pointer' : 'not-allowed',
//                                 transition: 'opacity 0.2s ease',
//                             }}
//                         >
//                             Kasse
//                         </Link>
//                     </figure>
//                 </div>
//             </div>
//         );
//     }, [
//         availableCartProducts, unavailableCartProducts, unavailableBanner, ageBlockedBanner, ageBanners,
//         cartAmount, cartAmountFinal,
//         totalSavings30d, couponDiscount, hasSaleItems, appliedCoupon,
//         hasProducts, isLoggedIn, isCheckoutEnabled, missing, progress,
//         onlyDigitalProducts, showPopup, handleRemoveCoupon, handleRemoveItem,
//         cartIsEmpty, isLoadingCartProducts,
//         selectedCartProducts, hasSelectedProducts,
//     ]);

//     return (
//         <div
//             ref={rootRef}
//             className={`ps-cart--mini hover-container${isOpen ? ' is-open' : ''}`}
//             onMouseEnter={() => {
//                 clearTimeout(closeTimerRef.current);
//                 setShowCart(true);
//             }}
//             onMouseLeave={() => {
//                 if (pinned) return;
//                 clearTimeout(closeTimerRef.current);
//                 closeTimerRef.current = setTimeout(() => setShowCart(false), CLOSE_DELAY);
//             }}
//         >
//             <Link href="/account/shopping-cart" className="header__extra">
//                 <i className="icon-bag2" />
//                 <span className={`cart-count ${pulseCartCount ? 'pulse' : ''}`}><i>{totalQuantity}</i></span>
//             </Link>
//             <span
//                 className="header__extra_text"
//                 style={{
//                     cursor: 'default',
//                     position: 'relative',
//                     zIndex: 5,
//                     pointerEvents: 'auto',
//                     userSelect: 'text',
//                     WebkitUserSelect: 'text',
//                 }}
//                 onClick={() => {
//                     clearTimeout(closeTimerRef.current);
//                     if (pinned) {
//                         setPinned(false);
//                     } else {
//                         setPinned(true);
//                         setShowCart(true);
//                     }
//                 }}
//             >
//                 <span>Warenkorb</span>
//             </span>
//             {isOpen && (
//                 <>
//                     <div className="dropdown-arrow"></div>
//                     {cartItemsContent}
//                 </>
//             )}
//             {confirmRemoveModal}

//             <style jsx>{`
//                 .hover-container { position: relative; }
//                 .ps-cart--mini { display: flex; flex-direction: column; align-items: center; font-size: 12px; }
//                 .header__extra { display: flex; flex-direction: column; align-items: center; }
//                 .header__extra_text { margin-top: 5px; display: flex; align-items: center; justify-content: center; }
//                 .cart-count { display: flex; min-width: 20px; height: 20px; border-radius: 50%; background: #ff6b6b; color: white; font-weight: bold; font-size: 12px; align-items: center; justify-content: center; margin-top: 2px; line-height: 1; }
//                 .cart-count i { font-style: normal; }
//                 .cart-count.pulse { animation: pulse 0.5s ease-in-out; }
//                 .ps-product__variants { margin-top: 4px; }
//                 .ps-product__variant { margin-bottom: 4px; }
//                 .ps-cart__content .ps-cart__items { margin-top: 20px; padding-bottom: 12px; border-bottom: 1px solid #000; }
//                 .ps-cart__content { position: absolute; top: 100%; left: 0; margin-top: 12px; width: ${MINICART_WIDTH}px; max-width: calc(100vw - 24px); background: #fff; border-radius: 0; border: 1px solid rgba(0,0,0,0.08); border-bottom: 1px solid #000 !important; box-shadow: 0 8px 32px rgba(0,0,0,0.12); z-index: 2147483647 !important; }
//                 .ps-cart__footer { padding: 16px 20px; }
//                 .ps-cart__footer figure { margin: 0; display: flex; gap: 8px; }
//                 .dropdown-arrow { position: absolute; top: 74px; right: 20px; width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid #ffffff; filter: drop-shadow(0 -2px 4px rgba(0,0,0,0.1)); z-index: 2147483647 !important; }

//                 /* Die unsichtbare Hover-Brücke aus HeaderActions.jsx lag über dem Text
//                    "Warenkorb" und hat alle Klicks geschluckt. Hier klickdurchlässig machen. */
//                 :global(.ps-cart__content::before) {
//                     pointer-events: none !important;
//                 }

//                 /* Wichtig: _cart.scss blendet .ps-cart__content ausserhalb von :hover aus.
//                    Mit is-open bleibt der Inhalt sichtbar, auch wenn die Maus weg ist. */
//                 .ps-cart--mini.is-open .ps-cart__content {
//                     visibility: visible !important;
//                     opacity: 1 !important;
//                     transform: translate(0, 0) !important;
//                     pointer-events: auto !important;
//                 }

//                 @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.5); } 100% { transform: scale(1); } }
//                 @keyframes minicart-spin { to { transform: rotate(360deg); } }
//                 :global(.minicart-unavailable-banner) {
//                     display: flex;
//                     align-items: flex-start;
//                     gap: 8px;
//                     margin: 20px 20px 0;
//                     padding: 8px 10px;
//                     border: 1px solid #f0b429;
//                     border-radius: 6px;
//                     background: #fffaf0;
//                     font-size: 11px;
//                     line-height: 1.4;
//                     color: #7a5b00;
//                     font-weight: 600;
//                 }
//                 :global(.minicart-unavailable-icon) {
//                     display: inline-flex;
//                     align-items: center;
//                     justify-content: center;
//                     width: 16px;
//                     height: 16px;
//                     border-radius: 50%;
//                     background: #f0b429;
//                     color: #fff;
//                     font-weight: 800;
//                     font-size: 11px;
//                     flex-shrink: 0;
//                 }
//                 :global(.minicart-age-blocked-banner) {
//                     border-color: #d9534f;
//                     background: #fff5f5;
//                     color: #7a0f0e;
//                 }
//                 :global(.minicart-age-blocked-icon) { background: #b11211; }
//                 :global(.minicart-age-banner) {
//                     display: flex;
//                     align-items: flex-start;
//                     gap: 8px;
//                     margin: 10px 20px 0;
//                     padding: 8px 10px;
//                     border: 1px solid #b11211;
//                     border-radius: 6px;
//                     background: #fff5f5;
//                     font-size: 11px;
//                     line-height: 1.4;
//                     color: #7a0f0e;
//                     font-weight: 600;
//                 }
//                 :global(.minicart-age-banner--16) {
//                     border-color: #e07b00;
//                     background: #fff7ec;
//                     color: #7a4200;
//                 }
//                 :global(.minicart-age-banner--18) {
//                     border-color: #b11211;
//                     background: #fff5f5;
//                     color: #7a0f0e;
//                 }
//                 :global(.minicart-age-icon) {
//                     display: inline-flex;
//                     align-items: center;
//                     justify-content: center;
//                     min-width: 22px;
//                     height: 22px;
//                     border-radius: 4px;
//                     color: #fff;
//                     font-weight: 800;
//                     font-size: 11px;
//                     flex-shrink: 0;
//                 }
//                 :global(.minicart-age-icon--16) { background: #e07b00; }
//                 :global(.minicart-age-icon--18) { background: #b11211; }
//                 :global(.minicart-loading) { border-bottom: none; }
//                 :global(.minicart-spinner) {
//                     width: 28px;
//                     height: 28px;
//                     border-radius: 50%;
//                     border: 3px solid rgba(0,0,0,0.1);
//                     border-top-color: #06c;
//                     animation: minicart-spin 0.7s linear infinite;
//                 }
//                 :global(.ps-btn--disabled) {
//                     opacity: 0.45;
//                     pointer-events: none;
//                     cursor: not-allowed;
//                 }
//             `}</style>
//         </div>
//     );
// };

// export default MiniCart;


// /var/www/frontend/src/components/shared/headers/modules/MiniCart.jsx
import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import OnCartProduct from '~/components/elements/products/OnCartProduct';
import useEcomerce from '~/hooks/useEcomerce';
import { calculateAmount } from '~/utilities/ecomerce-helpers';
import useGetProducts from '~/hooks/useGetProducts';
import useUserBirthday from '~/hooks/useUserBirthday';
import { useGlobalPopup } from '~/components/GlobalPopupProvider';
import {
    groupAgeRatings,
    splitProductsByUserAge,
    getAgeBlockedText,
} from '~/utilities/ageCheck';
import { getCouponLabel } from '~/utilities/checkoutTotals';
import { isCartItemSelected } from '~/utilities/cartSelection';
import { useConfirmRemove } from '~/components/elements/products/modules/ConfirmRemoveModal';

const MIN_ORDER_VALUE = 20.00;
const MINICART_WIDTH = 400;
const BOX_ICON_SIZE = 18;

const BOX_ICON_BOX_WIDTH = 26;
const BOX_ICON_BOX_HEIGHT = 26;

const SALE_ICON_SIZE = 18;
const SALE_BOX_WIDTH = 26;
const SALE_BOX_HEIGHT = 26;

const CLOSE_DELAY = 250;

const placeholderURL = '/static/img/products/rawento-product-placeholder.webp';

const buildImageUrl = (image) => {
    if (!image || image === 'No base_image_thumbnail') return placeholderURL;
    if (String(image).startsWith('http')) return image;
    return `${process.env.NEXT_PUBLIC_FRONTEND_URL}/images/${image}`;
};

const readCouponFromStorage = () => {
    try {
        const saved = typeof window !== 'undefined' ? localStorage.getItem('appliedCoupon') : null;
        return saved ? JSON.parse(saved) : null;
    } catch (e) { return null; }
};

const EuroSup = () => (
    <sup
        style={{
            fontSize: '0.6em',
            fontWeight: 500,
            marginLeft: '1px',
            lineHeight: 0,
        }}
    >
        €
    </sup>
);

const MiniCart = () => {
    const { removeItem } = useEcomerce();
    const { showPopup } = useGlobalPopup();
    const { confirmRemove, confirmRemoveModal } = useConfirmRemove();
    const cartItems = useSelector(({ ecomerce }) => ecomerce.cartItems);
    const isLoggedIn = typeof window !== 'undefined' && !!localStorage.getItem('jwt');
    const { getStrapiProducts, products } = useGetProducts();
    const birthday = useUserBirthday();

    const [pulseCartCount, setPulseCartCount] = useState(false);
    const [showCart, setShowCart] = useState(false);
    const [pinned, setPinned] = useState(false);

    const [appliedCoupon, setAppliedCoupon] = useState(readCouponFromStorage);

    const rootRef = useRef(null);
    const closeTimerRef = useRef(null);
    const prevCartTotalRef = useRef(0);
    const isInitialMountRef = useRef(true);
    const mountedRef = useRef(false);

    const isOpen = showCart || pinned;

    useEffect(() => {
        return () => clearTimeout(closeTimerRef.current);
    }, []);

    useEffect(() => {
        if (!pinned) return;

        const onDown = (e) => {
            if (rootRef.current && rootRef.current.contains(e.target)) return;
            if (
                e.target.closest &&
                e.target.closest('[role="dialog"], [class*="modal"], [class*="popup"]')
            ) return;
            setPinned(false);
            setShowCart(false);
        };
        const onKey = (e) => {
            if (e.key === 'Escape') {
                setPinned(false);
                setShowCart(false);
            }
        };

        document.addEventListener('mousedown', onDown);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [pinned]);

    useEffect(() => {
        if (!isOpen || !rootRef.current) return;
        const el = rootRef.current.querySelector('.ps-cart__content');
        if (!el) return;
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('pointer-events', 'auto', 'important');
        el.style.setProperty('transform', 'translate(0, 0)', 'important');
    });

    useEffect(() => {
        const sync = () => {
            const fresh = readCouponFromStorage();
            setAppliedCoupon((prev) => {
                const prevStr = prev ? JSON.stringify(prev) : 'null';
                const freshStr = fresh ? JSON.stringify(fresh) : 'null';
                return prevStr === freshStr ? prev : fresh;
            });
        };
        const onStorage = (e) => { if (e.key === 'appliedCoupon') sync(); };

        window.addEventListener('couponChanged', sync);
        window.addEventListener('storage', onStorage);
        return () => {
            window.removeEventListener('couponChanged', sync);
            window.removeEventListener('storage', onStorage);
        };
    }, []);

    useEffect(() => {
        const validateCouponOnMount = async () => {
            const saved = readCouponFromStorage();
            if (!saved?.code) return;

            try {
                const token = typeof window !== 'undefined' ? localStorage.getItem('jwt') : null;
                const userRaw = typeof window !== 'undefined' ? localStorage.getItem('user') : null;
                if (!token || !userRaw) return;

                let user = null;
                try { user = JSON.parse(userRaw); } catch (e) { return; }
                const email = user?.email || user?.data?.email || user?.user?.email || '';
                if (!email) return;

                const response = await fetch(
                    `${process.env.NEXT_PUBLIC_API_URL}/newsletters/status?email=${encodeURIComponent(email)}`,
                    { headers: { Authorization: `Bearer ${token}` }, cache: 'no-store' }
                );
                if (!response.ok) return;
                const data = await response.json();

                if (
                    data?.welcome_coupon_redeemed &&
                    data?.welcome_coupon_code?.toLowerCase() === saved.code.toLowerCase()
                ) {
                    try { localStorage.removeItem('appliedCoupon'); } catch (e) {}
                    setAppliedCoupon(null);
                    setTimeout(() => window.dispatchEvent(new Event('couponChanged')), 0);
                }
            } catch (e) {
                console.error('MiniCart coupon validation failed:', e);
            }
        };

        validateCouponOnMount();
    }, []);

    const handleRemoveCoupon = useCallback(async () => {
        const confirmed = await confirmRemove({
            title: 'Aktionscode entfernen?',
            message: 'Möchtest du den Aktionscode wirklich entfernen? Der Rabatt wird dann nicht mehr auf deine Bestellung angewendet.',
            itemName: appliedCoupon?.code || '',
        });
        if (!confirmed) return;
        try { localStorage.removeItem('appliedCoupon'); } catch (e) {}
        setAppliedCoupon(null);
        setTimeout(() => window.dispatchEvent(new Event('couponChanged')), 0);
        showPopup({ type: 'success', title: 'Entfernt', detail: 'Aktionscode wurde entfernt.' });
    }, [confirmRemove, appliedCoupon, showPopup]);

    const handleRemoveItem = useCallback(async (e, productId, productTitle, info = {}) => {
        e.preventDefault();
        e.stopPropagation();

        const confirmed = await confirmRemove({
            title: 'Aus Warenkorb entfernen?',
            message: 'Artikel aus deinem Warenkorb entfernen?',
            itemName: productTitle || '',
            imageUrl: buildImageUrl(info.image),
            price: info.price,
            oldPrice: info.oldPrice,
            quantity: info.quantity,
        });
        if (!confirmed) return;

        try {
            await removeItem({ id: productId }, cartItems, 'cart');
            showPopup({ type: 'info', title: 'Artikel entfernt', detail: `„${productTitle || 'Artikel'}" wurde aus dem Warenkorb entfernt.` });
        } catch (err) {
            console.error('Error removing item:', err);
            showPopup({ type: 'error', title: 'Fehler', detail: 'Artikel konnte nicht entfernt werden.' });
        }
    }, [confirmRemove, removeItem, cartItems, showPopup]);

    function getCartProducts() {
        if (cartItems.length > 0) {
            const query = {
                filters: { id: { $in: cartItems.map((item) => item.id) } },
                populate: { shippings: { fields: ['shipping_type', 'shipping_cost'] } },
            };
            getStrapiProducts(query);
        }
    }

    useEffect(() => { getCartProducts(); }, [cartItems]);

    const totalQuantity = useMemo(() => cartItems.reduce((total, item) => total + (item.quantity || 1), 0), [cartItems]);

    const triggerPulseIfAdded = useCallback(() => {
        const currentTotal = totalQuantity;
        const prevTotal = prevCartTotalRef.current;
        if (mountedRef.current && !isInitialMountRef.current && currentTotal > prevTotal) {
            setPulseCartCount(true);
            setTimeout(() => setPulseCartCount(false), 500);
        }
        prevCartTotalRef.current = currentTotal;
    }, [totalQuantity]);

    useEffect(() => { mountedRef.current = true; return () => { mountedRef.current = false; }; }, []);
    useEffect(() => {
        if (isInitialMountRef.current) { isInitialMountRef.current = false; prevCartTotalRef.current = totalQuantity; return; }
        triggerPulseIfAdded();
    }, [totalQuantity, triggerPulseIfAdded]);

    const cartProducts = useMemo(() => {
        if (cartItems.length === 0) return [];
        return products.map((product) => {
            const attrs = product?.attributes || {};
            const variants = [];

            for (let n = 1; n <= 4; n += 1) {
                const name = attrs[`variant_name_${n}`];
                const value = attrs[`variant_value_${n}`];

                if (name && value) variants.push(`${name} ${value}`);
            }

            const shippingInfo = product?.attributes?.shippings?.data?.attributes;
            const shipping_type = shippingInfo?.shipping_type || '';
            const cartItem = cartItems.find((item) => String(item.id) === String(product.id));
            const currentQuantity = cartItem?.quantity ?? 0;
            const lowestPrice30d =
                product.attributes.lowestPrice30d != null ? Number(product.attributes.lowestPrice30d) : null;

            const inStockRaw = product?.attributes?.in_stock;
            const hasStockInfo = inStockRaw === true || inStockRaw === false;
            const isAvailable = !hasStockInfo || inStockRaw === true;

            const minAge = Number(product?.attributes?.minAge) || 0;
            const ageRatingType = product?.attributes?.age_rating_type || null;

            return {
                id: product.id,
                title: product.attributes.title || 'Untitled Product',
                slug: product.attributes.slug || 'untitled-product',
                thumbnailImage: product.attributes.thumbnail || null,
                price: product.attributes.price || 0,
                lowestPrice30d,
                base_image_thumbnail: product.attributes.base_image_thumbnail || null,
                quantity: currentQuantity,
                productVariants: variants,
                shipping_type,
                isAvailable,
                minAge,
                ageRatingType,
                selected: isCartItemSelected(cartItem),
            };
        });
    }, [products, cartItems]);

    const inStockCartProducts = useMemo(
        () => cartProducts.filter((p) => p.isAvailable),
        [cartProducts]
    );
    const unavailableCartProducts = useMemo(
        () => cartProducts.filter((p) => !p.isAvailable),
        [cartProducts]
    );

    const ageSplit = useMemo(
        () => splitProductsByUserAge(inStockCartProducts, birthday),
        [inStockCartProducts, birthday]
    );
    const availableCartProducts = ageSplit.allowed;
    const ageBlockedCartProducts = ageSplit.blocked;

    // Nur die zur Kasse ausgewählten Artikel zählen für Summe, Altersprüfung und Kasse
    const selectedCartProducts = useMemo(
        () => availableCartProducts.filter((p) => p.selected),
        [availableCartProducts]
    );

    const ageGroups = useMemo(
        () => groupAgeRatings(selectedCartProducts),
        [selectedCartProducts]
    );

    const cartIsEmpty = cartItems.length === 0;

    const isLoadingCartProducts = !cartIsEmpty && cartProducts.length === 0;

    const cartAmount = useMemo(
        () => selectedCartProducts.reduce((sum, p) => sum + p.price * p.quantity, 0),
        [selectedCartProducts]
    );

    const totalSavings30d = useMemo(
        () =>
            selectedCartProducts.reduce((sum, p) => {
                if (p.lowestPrice30d != null && p.lowestPrice30d > p.price) {
                    return sum + (p.lowestPrice30d - p.price) * p.quantity;
                }
                return sum;
            }, 0),
        [selectedCartProducts]
    );
    const hasSaleItems = useMemo(
        () => selectedCartProducts.some((p) => p.lowestPrice30d != null && p.lowestPrice30d > p.price),
        [selectedCartProducts]
    );

    const couponDiscount = useMemo(() => {
        const amount = Number(appliedCoupon?.welcome_coupon_discount_amount);
        if (!appliedCoupon || !amount || amount <= 0) return 0;

        if (appliedCoupon.welcome_coupon_discount_type === 'percent') {
            return Math.round(cartAmount * (amount / 100) * 100) / 100;
        }

        return Math.min(amount, cartAmount);
    }, [cartAmount, appliedCoupon]);
    const cartAmountFinal = useMemo(() => cartAmount - couponDiscount, [cartAmount, couponDiscount]);

    const hasProducts = availableCartProducts.length > 0;
    const hasSelectedProducts = selectedCartProducts.length > 0;

    // Warenkorb ist nicht leer, aber es ist nichts bestellbar
    // (alle Artikel nicht lieferbar und/oder wegen Altersprüfung gesperrt)
    const nothingOrderable = !cartIsEmpty && !isLoadingCartProducts && !hasProducts;

    const onlyDigitalProducts = useMemo(
        () =>
            hasSelectedProducts &&
            selectedCartProducts.every(
                (product) => product.shipping_type === 'Digitaler Versand'
            ),
        [selectedCartProducts, hasSelectedProducts]
    );

    const isCheckoutEnabled = useMemo(
        () => hasSelectedProducts && (onlyDigitalProducts || cartAmount >= MIN_ORDER_VALUE),
        [hasSelectedProducts, onlyDigitalProducts, cartAmount]
    );

    const missing = isCheckoutEnabled
        ? 0
        : Math.max(0, MIN_ORDER_VALUE - cartAmount);

    const progress = isCheckoutEnabled
        ? 100
        : Math.min(100, (cartAmount / MIN_ORDER_VALUE) * 100);

    const formatAmount = (amount) =>
        new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);

    const currencyStyle   = { fontSize: '0.65em', fontWeight: 500, marginLeft: '1px' };
    const emptyCartStyle  = { display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '24px 12px', borderBottom: 'none' };
    const imgStyle        = { maxWidth: '100%', height: 'auto', display: 'block', width: '21.5rem', objectFit: 'contain' };
    const titleStyle      = { margin: '16px 0px 0px', fontSize: '21px', fontWeight: '600', lineHeight: '27.3px', textAlign: 'center' };
    const subtitleStyle   = { margin: '0px 0px 24px', fontSize: '14px', fontWeight: '400', lineHeight: '21px', textAlign: 'center', color: '#666' };
    const rowStyle        = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', color: '#444', marginBottom: '5px' };
    const discountStyle   = { color: '#b11211', fontWeight: 600, whiteSpace: 'nowrap' };
    const couponStyle     = { color: '#1a7a32', fontWeight: 600, whiteSpace: 'nowrap' };
    const dividerStyle    = { border: 'none', borderTop: '1px solid rgba(0,0,0,0.1)', margin: '8px 0' };

    const unavailableBanner = unavailableCartProducts.length > 0 ? (
        <div className="minicart-unavailable-banner">
            <span className="minicart-unavailable-icon">!</span>
            <span>
                {unavailableCartProducts.length === 1
                    ? '1 Artikel ist aktuell nicht verfügbar und wird nicht mit bestellt.'
                    : `${unavailableCartProducts.length} Artikel sind aktuell nicht verfügbar und werden nicht mit bestellt.`}
            </span>
        </div>
    ) : null;

    const ageBlockedBanner = ageBlockedCartProducts.length > 0 ? (
        <div className="minicart-unavailable-banner minicart-age-blocked-banner">
            <span className="minicart-unavailable-icon minicart-age-blocked-icon">!</span>
            <span>{getAgeBlockedText(ageBlockedCartProducts)}</span>
        </div>
    ) : null;

    const ageBanners = ageGroups.map((group) => (
        <div
            key={group.key}
            className={`minicart-age-banner minicart-age-banner--${group.limit}`}
        >
            <span className={`minicart-age-icon minicart-age-icon--${group.limit}`}>
                {group.limit}
            </span>
            <span>
                {group.count === 1 ? '1 Artikel' : `${group.count} Artikel`} ab {group.limit} Jahren ({group.label}).{' '}
                {group.limit === 18
                    ? 'Vor der Bestellung ist eine Altersverifizierung erforderlich, zusätzliche Prüfung bei Zustellung durch DHL.'
                    : 'Das Alter wird bei Zustellung durch DHL geprüft.'}
            </span>
        </div>
    ));

    const loadingPlaceholder = (
        <div className="ps-cart__items minicart-loading" style={emptyCartStyle}>
            <div className="minicart-spinner" />
            <p style={{ ...subtitleStyle, margin: '12px 0 0' }}>Warenkorb wird geladen …</p>
        </div>
    );

    const cartItemsContent = useMemo(() => {
        if (!isLoggedIn && cartIsEmpty) {
            return (
                <div className="ps-cart__content">
                    <div className="ps-cart__items" style={emptyCartStyle}>
                        <img role="presentation" src="/static/img/sale/empty-cart.svg" alt="" style={{ ...imgStyle, width: '75px', height: '75px' }} />
                        <p style={titleStyle}>Dein Warenkorb ist noch leer</p>
                        <p style={subtitleStyle}>Viele Produkte warten auf dich!</p>
                        <div style={{ width: '100%', padding: '0 20px', display: 'flex', justifyContent: 'center' }}>
                            <Link href="/account/login" className="ps-btn">Jetzt anmelden</Link>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="ps-cart__content">
                {unavailableBanner}
                {ageBlockedBanner}
                {ageBanners}

                {isLoadingCartProducts ? (
                    loadingPlaceholder
                ) : hasProducts ? (
                    <div className="ps-cart__items">
                        {availableCartProducts.map((item) => (
                            <OnCartProduct
                                product={item}
                                quantity={item.quantity}
                                key={item.id}
                                onAddToQueue={showPopup}
                                onRemove={(e) => handleRemoveItem(e, item.id, item.title, {
                                    image: item.base_image_thumbnail,
                                    price: item.price,
                                    oldPrice: item.lowestPrice30d != null && item.lowestPrice30d > item.price ? item.lowestPrice30d : null,
                                    quantity: item.quantity,
                                })}
                            >
                                {item.productVariants.length > 0 && (
                                    <div className="ps-product__variants">
                                        {item.productVariants.map((variant, index) => {
                                            const [name, ...valueParts] = variant.split(' ');
                                            const value = valueParts.join(' ');
                                            const displayName = name.includes(':') ? name : `${name}:`;
                                            return (<div key={index} className="ps-product__variant"><strong>{displayName}</strong> {value}</div>);
                                        })}
                                    </div>
                                )}
                                {!item.selected && (
                                    <div className="ps-product__variant" style={{ color: '#b11211' }}>
                                        Nicht für die Kasse ausgewählt
                                    </div>
                                )}
                            </OnCartProduct>
                        ))}
                    </div>
                ) : cartIsEmpty ? (
                    <div className="ps-cart__items" style={emptyCartStyle}>
                        <img role="presentation" src="/static/img/sale/empty-cart.svg" alt="" style={{ ...imgStyle, width: '75px', height: '75px' }} />
                        <p style={titleStyle}>Dein Warenkorb ist noch leer</p>
                        <p style={subtitleStyle}>Viele Produkte warten auf dich!</p>
                    </div>
                ) : (
                    /* Nichts bestellbar: nicht lieferbare Artikel ausgegraut anzeigen + Hinweis */
                    <div className="ps-cart__items minicart-nothing-orderable">
                        {unavailableCartProducts.map((item) => (
                            <div key={item.id} className="minicart-unavail-item">
                                <img
                                    src={buildImageUrl(item.base_image_thumbnail)}
                                    alt=""
                                    className="minicart-unavail-img"
                                />
                                <div className="minicart-unavail-info">
                                    <span className="minicart-unavail-title">{item.title}</span>
                                    <span className="minicart-unavail-label">Aktuell nicht verfügbar</span>
                                </div>
                                <button
                                    type="button"
                                    className="minicart-unavail-remove"
                                    aria-label="Artikel entfernen"
                                    title="Artikel entfernen"
                                    onClick={(e) => handleRemoveItem(e, item.id, item.title, {
                                        image: item.base_image_thumbnail,
                                        price: item.price,
                                        oldPrice: item.lowestPrice30d != null && item.lowestPrice30d > item.price ? item.lowestPrice30d : null,
                                        quantity: item.quantity,
                                    })}
                                >
                                    ✕
                                </button>
                            </div>
                        ))}

                        <div style={{ ...emptyCartStyle, padding: '8px 12px 8px' }}>
                            <img role="presentation" src="/static/img/sale/empty-cart.svg" alt="" style={{ ...imgStyle, width: '56px', height: '56px' }} />
                            <p style={{ ...titleStyle, margin: '10px 0 0', fontSize: '17px', lineHeight: '22px' }}>
                                Aktuell ist nichts bestellbar
                            </p>
                            <p style={{ ...subtitleStyle, margin: '4px 0 0', fontSize: '13px', lineHeight: '19px' }}>
                                Schau später noch einmal vorbei oder entferne die Artikel.
                            </p>
                        </div>
                    </div>
                )}

                <div className="ps-cart__footer">
                    {hasProducts && (
                        <>
                            <div style={{ marginBottom: '10px' }}>

                                {hasSaleItems && totalSavings30d > 0 && (
                                    <div style={{ display: 'block', width: '100%', padding: 0, margin: '0 0 8px' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                width: '100%',
                                                backgroundColor: '#ffffff',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                height: `${SALE_BOX_HEIGHT}px`,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    flexDirection: 'column',
                                                    backgroundColor: 'rgb(177, 18, 17)',
                                                    padding: 0,
                                                    width: `${SALE_BOX_WIDTH}px`,
                                                    minWidth: `${SALE_BOX_WIDTH}px`,
                                                    alignItems: 'center',
                                                    boxSizing: 'border-box',
                                                }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={SALE_ICON_SIZE}
                                                    height={SALE_ICON_SIZE}
                                                    viewBox="0 0 24 24"
                                                    fill="white"
                                                >
                                                    <path d="M21.41 11.58L12.41 2.58A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.84ZM7 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" />
                                                </svg>
                                            </div>

                                            <div
                                                style={{
                                                    flex: 'auto',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '0 8px',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        flex: '1 1 auto',
                                                        minWidth: 0,
                                                        fontSize: '1.4rem',
                                                        lineHeight: '1.4285714286em',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    SALE Sie sparen:
                                                </div>

                                                <div
                                                    style={{
                                                        flex: '0 0 auto',
                                                        marginLeft: 'auto',
                                                        textAlign: 'right',
                                                        fontWeight: 700,
                                                        fontSize: '1.4rem',
                                                        lineHeight: '1.4285714286em',
                                                        whiteSpace: 'nowrap',
                                                        color: 'rgb(177, 18, 17)',
                                                    }}
                                                >
                                                    <strong>
                                                        {formatAmount(totalSavings30d)}
                                                        <EuroSup />
                                                    </strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div style={rowStyle}>
                                    <span>Zwischensumme</span>
                                    <span style={{ fontWeight: 500 }}>
                                        {formatAmount(cartAmount)}<sup style={currencyStyle}>€</sup>
                                    </span>
                                </div>

                                {appliedCoupon?.code && couponDiscount > 0 && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            backgroundColor: 'transparent',
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            margin: '8px 0',
                                            height: `${BOX_ICON_BOX_HEIGHT}px`,
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                backgroundColor: '#3E935E',
                                                padding: 0,
                                                width: `${BOX_ICON_BOX_WIDTH}px`,
                                                minWidth: `${BOX_ICON_BOX_WIDTH}px`,
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            <img
                                                src="/static/img/icons/icon-sale.svg"
                                                alt="Aktionscode"
                                                width={BOX_ICON_SIZE}
                                                height={BOX_ICON_SIZE}
                                                style={{
                                                    filter: 'brightness(0) invert(1)',
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                flex: 'auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '0 8px',
                                                gap: '4px',
                                                flexWrap: 'nowrap',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    flex: '1 1 auto',
                                                    minWidth: 0,
                                                    fontSize: '1.2rem',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    lineHeight: '1.4285714286em',
                                                }}
                                            >
                                                Aktionscode{' '}
                                                <strong>{appliedCoupon.code}</strong>{' '}
                                                – {getCouponLabel(appliedCoupon)}
                                            </div>

                                            <div
                                                style={{
                                                    flex: '0 0 auto',
                                                    marginLeft: 'auto',
                                                    textAlign: 'right',
                                                    fontWeight: 700,
                                                    fontSize: '1.2rem',
                                                    lineHeight: '1.4285714286em',
                                                    whiteSpace: 'nowrap',
                                                    color: 'rgb(177, 18, 17)',
                                                }}
                                            >
                                                <strong>
                                                    −{formatAmount(couponDiscount)}
                                                    <EuroSup />
                                                </strong>
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            onClick={handleRemoveCoupon}
                                            aria-label="Aktionscode entfernen"
                                            title="Aktionscode entfernen"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flex: '0 0 auto',
                                                width: '28px',
                                                padding: 0,
                                                border: 0,
                                                background: 'transparent',
                                                color: '#888',
                                                fontSize: '12px',
                                                lineHeight: 1,
                                                cursor: 'pointer',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.color = '#b11211')}
                                            onMouseLeave={(e) => (e.currentTarget.style.color = '#888')}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )}

                                <hr style={dividerStyle} />

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '3px' }}>
                                    <span style={{ fontSize: '13px', fontWeight: 700, color: '#111' }}>
                                        Gesamtsumme{' '}
                                        <span style={{ fontSize: '11px', fontWeight: 400, color: '#777' }}>(inkl. MwSt.)</span>
                                    </span>
                                    <span style={{ fontSize: '15px', fontWeight: 700, color: '#111' }}>
                                        {formatAmount(cartAmountFinal)}<sup style={currencyStyle}>€</sup>
                                    </span>
                                </div>

                                {!onlyDigitalProducts && (
                                    <div style={{ fontSize: '11px', color: '#777' }}>zzgl. Versandkosten</div>
                                )}
                            </div>

                            {hasSelectedProducts && !isCheckoutEnabled && !onlyDigitalProducts && (
                                <div style={{ marginBottom: '12px' }}>
                                    <p style={{ fontSize: '12px', margin: '0 0 6px 0', color: '#333', lineHeight: '1.4' }}>
                                        Es fehlen <strong>{formatAmount(missing)}<sup style={currencyStyle}>€</sup></strong> bis zum Mindestbestellwert von {formatAmount(MIN_ORDER_VALUE)}<sup style={currencyStyle}>€</sup>
                                    </p>
                                    <div style={{ position: 'relative', height: '6px', borderRadius: '999px', background: 'rgb(211,211,211)', overflow: 'hidden' }}>
                                        <div style={{ height: '6px', width: `${progress}%`, background: 'rgb(0,100,0)', transition: 'width 0.15s ease-out' }} />
                                    </div>
                                </div>
                            )}

                            {hasProducts && !hasSelectedProducts && (
                                <p style={{ fontSize: '12px', margin: '0 0 12px', color: '#b11211' }}>
                                    Wähle im Warenkorb mindestens einen Artikel für die Kasse aus.
                                </p>
                            )}
                        </>
                    )}

                    <hr style={dividerStyle} />

                    <figure>
                        <Link href="/account/shopping-cart" className="ps-btn">Warenkorb</Link>
                        <Link
                            href={isCheckoutEnabled ? '/account/checkout' : '#'}
                            className={`ps-btn ${isCheckoutEnabled ? '' : 'ps-btn--disabled'}`}
                            aria-disabled={!isCheckoutEnabled}
                            tabIndex={isCheckoutEnabled ? 0 : -1}
                            onClick={(event) => {
                                if (!isCheckoutEnabled) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            }}
                            style={{
                                opacity: isCheckoutEnabled ? 1 : 0.45,
                                pointerEvents: isCheckoutEnabled ? 'auto' : 'none',
                                cursor: isCheckoutEnabled ? 'pointer' : 'not-allowed',
                                transition: 'opacity 0.2s ease',
                            }}
                        >
                            Kasse
                        </Link>
                    </figure>
                </div>
            </div>
        );
    }, [
        availableCartProducts, unavailableCartProducts, ageBlockedCartProducts, unavailableBanner, ageBlockedBanner, ageBanners,
        cartAmount, cartAmountFinal,
        totalSavings30d, couponDiscount, hasSaleItems, appliedCoupon,
        hasProducts, isLoggedIn, isCheckoutEnabled, missing, progress,
        onlyDigitalProducts, showPopup, handleRemoveCoupon, handleRemoveItem,
        cartIsEmpty, isLoadingCartProducts, nothingOrderable,
        selectedCartProducts, hasSelectedProducts,
    ]);

    return (
        <div
            ref={rootRef}
            className={`ps-cart--mini hover-container${isOpen ? ' is-open' : ''}`}
            onMouseEnter={() => {
                clearTimeout(closeTimerRef.current);
                setShowCart(true);
            }}
            onMouseLeave={() => {
                if (pinned) return;
                clearTimeout(closeTimerRef.current);
                closeTimerRef.current = setTimeout(() => setShowCart(false), CLOSE_DELAY);
            }}
        >
            <Link href="/account/shopping-cart" className="header__extra">
                <i className="icon-bag2" />
                <span className={`cart-count ${pulseCartCount ? 'pulse' : ''}`}><i>{totalQuantity}</i></span>
            </Link>
            <span
                className="header__extra_text"
                style={{
                    cursor: 'default',
                    position: 'relative',
                    zIndex: 5,
                    pointerEvents: 'auto',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                }}
                onClick={() => {
                    clearTimeout(closeTimerRef.current);
                    if (pinned) {
                        setPinned(false);
                    } else {
                        setPinned(true);
                        setShowCart(true);
                    }
                }}
            >
                <span>Warenkorb</span>
            </span>
            {isOpen && (
                <>
                    <div className="dropdown-arrow"></div>
                    {cartItemsContent}
                </>
            )}
            {confirmRemoveModal}

            <style jsx>{`
                .hover-container { position: relative; }
                .ps-cart--mini { display: flex; flex-direction: column; align-items: center; font-size: 12px; }
                .header__extra { display: flex; flex-direction: column; align-items: center; }
                .header__extra_text { margin-top: 5px; display: flex; align-items: center; justify-content: center; }
                .cart-count { display: flex; min-width: 20px; height: 20px; border-radius: 50%; background: #ff6b6b; color: white; font-weight: bold; font-size: 12px; align-items: center; justify-content: center; margin-top: 2px; line-height: 1; }
                .cart-count i { font-style: normal; }
                .cart-count.pulse { animation: pulse 0.5s ease-in-out; }
                .ps-product__variants { margin-top: 4px; }
                .ps-product__variant { margin-bottom: 4px; }
                .ps-cart__content .ps-cart__items { margin-top: 20px; padding-bottom: 12px; border-bottom: 1px solid #000; }
                .ps-cart__content { position: absolute; top: 100%; left: 0; margin-top: 12px; width: ${MINICART_WIDTH}px; max-width: calc(100vw - 24px); background: #fff; border-radius: 0; border: 1px solid rgba(0,0,0,0.08); border-bottom: 1px solid #000 !important; box-shadow: 0 8px 32px rgba(0,0,0,0.12); z-index: 2147483647 !important; }
                .ps-cart__footer { padding: 16px 20px; }
                .ps-cart__footer figure { margin: 0; display: flex; gap: 8px; }
                .dropdown-arrow { position: absolute; top: 74px; right: 20px; width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid #ffffff; filter: drop-shadow(0 -2px 4px rgba(0,0,0,0.1)); z-index: 2147483647 !important; }

                /* Die unsichtbare Hover-Brücke aus HeaderActions.jsx lag über dem Text
                   "Warenkorb" und hat alle Klicks geschluckt. Hier klickdurchlässig machen. */
                :global(.ps-cart__content::before) {
                    pointer-events: none !important;
                }

                /* Wichtig: _cart.scss blendet .ps-cart__content ausserhalb von :hover aus.
                   Mit is-open bleibt der Inhalt sichtbar, auch wenn die Maus weg ist. */
                .ps-cart--mini.is-open .ps-cart__content {
                    visibility: visible !important;
                    opacity: 1 !important;
                    transform: translate(0, 0) !important;
                    pointer-events: auto !important;
                }

                @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.5); } 100% { transform: scale(1); } }
                @keyframes minicart-spin { to { transform: rotate(360deg); } }
                :global(.minicart-unavailable-banner) {
                    display: flex;
                    align-items: flex-start;
                    gap: 8px;
                    margin: 20px 20px 0;
                    padding: 8px 10px;
                    border: 1px solid #f0b429;
                    border-radius: 6px;
                    background: #fffaf0;
                    font-size: 11px;
                    line-height: 1.4;
                    color: #7a5b00;
                    font-weight: 600;
                }
                :global(.minicart-unavailable-icon) {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    background: #f0b429;
                    color: #fff;
                    font-weight: 800;
                    font-size: 11px;
                    flex-shrink: 0;
                }
                :global(.minicart-age-blocked-banner) {
                    border-color: #d9534f;
                    background: #fff5f5;
                    color: #7a0f0e;
                }
                :global(.minicart-age-blocked-icon) { background: #b11211; }
                :global(.minicart-age-banner) {
                    display: flex;
                    align-items: flex-start;
                    gap: 8px;
                    margin: 10px 20px 0;
                    padding: 8px 10px;
                    border: 1px solid #b11211;
                    border-radius: 6px;
                    background: #fff5f5;
                    font-size: 11px;
                    line-height: 1.4;
                    color: #7a0f0e;
                    font-weight: 600;
                }
                :global(.minicart-age-banner--16) {
                    border-color: #e07b00;
                    background: #fff7ec;
                    color: #7a4200;
                }
                :global(.minicart-age-banner--18) {
                    border-color: #b11211;
                    background: #fff5f5;
                    color: #7a0f0e;
                }
                :global(.minicart-age-icon) {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 22px;
                    height: 22px;
                    border-radius: 4px;
                    color: #fff;
                    font-weight: 800;
                    font-size: 11px;
                    flex-shrink: 0;
                }
                :global(.minicart-age-icon--16) { background: #e07b00; }
                :global(.minicart-age-icon--18) { background: #b11211; }
                :global(.minicart-loading) { border-bottom: none; }
                :global(.minicart-spinner) {
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    border: 3px solid rgba(0,0,0,0.1);
                    border-top-color: #06c;
                    animation: minicart-spin 0.7s linear infinite;
                }

                /* Ansicht "nichts bestellbar": nicht lieferbare Artikel ausgegraut */
                :global(.minicart-nothing-orderable) {
                    border-bottom: none !important;
                    padding-bottom: 0 !important;
                }
                :global(.minicart-unavail-item) {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 8px 20px;
                }
                :global(.minicart-unavail-img) {
                    width: 56px;
                    height: 56px;
                    object-fit: contain;
                    flex-shrink: 0;
                    filter: grayscale(1);
                    opacity: 0.5;
                }
                :global(.minicart-unavail-info) {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    flex: 1 1 auto;
                    min-width: 0;
                }
                :global(.minicart-unavail-title) {
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.3;
                    color: #888;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                :global(.minicart-unavail-label) {
                    font-size: 11px;
                    font-weight: 600;
                    color: #b45f06;
                }
                :global(.minicart-unavail-remove) {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex: 0 0 auto;
                    width: 28px;
                    height: 28px;
                    padding: 0;
                    border: 0;
                    background: transparent;
                    color: #888;
                    font-size: 12px;
                    line-height: 1;
                    cursor: pointer;
                }
                :global(.minicart-unavail-remove:hover) { color: #b11211; }

                :global(.ps-btn--disabled) {
                    opacity: 0.45;
                    pointer-events: none;
                    cursor: not-allowed;
                }
            `}</style>
        </div>
    );
};

export default MiniCart;